// Personen-Motive: acht mehrfarbige Avatar-Illustrationen (von Anke über die
// Inbox geliefert, abgelegt in `avatars/`). Anders als die frühere einfarbige
// Font-Awesome-Silhouette ist jedes Motiv ein vollständiges, mehrfarbiges SVG
// (runde Portraits). Der Renderer zeichnet es deshalb als Bild (`Konva.Image`),
// nicht mehr als einzelnen `Konva.Path`. Jede Person wählt eines der acht.

import avatar1 from './avatars/person-1.svg?raw';
import avatar2 from './avatars/person-2.svg?raw';
import avatar3 from './avatars/person-3.svg?raw';
import avatar4 from './avatars/person-4.svg?raw';
import avatar5 from './avatars/person-5.svg?raw';
import avatar6 from './avatars/person-6.svg?raw';
import avatar7 from './avatars/person-7.svg?raw';
import avatar8 from './avatars/person-8.svg?raw';

export type PersonIcon =
  | 'person-1' | 'person-2' | 'person-3' | 'person-4'
  | 'person-5' | 'person-6' | 'person-7' | 'person-8';

export interface PersonIconDef {
  /** Vollständiges, mehrfarbiges SVG-Markup (als Bild gerendert). */
  readonly svg: string;
  /** viewBox-Breite / -Höhe für die Seitenverhältnis-Normalisierung. */
  readonly vbWidth: number;
  readonly vbHeight: number;
}

/** Liest Breite/Höhe aus der viewBox des SVG (Single Source of Truth). */
function readViewBox(svg: string): { vbWidth: number; vbHeight: number } {
  const m = svg.match(/viewBox="0 0 ([0-9.]+) ([0-9.]+)"/);
  return {
    vbWidth: m ? parseFloat(m[1]!) : 0,
    vbHeight: m ? parseFloat(m[2]!) : 0,
  };
}

function def(svg: string): PersonIconDef {
  return { svg, ...readViewBox(svg) };
}

export const PERSON_ICONS: Record<PersonIcon, PersonIconDef> = {
  'person-1': def(avatar1),
  'person-2': def(avatar2),
  'person-3': def(avatar3),
  'person-4': def(avatar4),
  'person-5': def(avatar5),
  'person-6': def(avatar6),
  'person-7': def(avatar7),
  'person-8': def(avatar8),
};

/** Default-Motiv für eine frische / motivlose (Alt-)Person. */
export const DEFAULT_PERSON_ICON: PersonIcon = 'person-1';

/**
 * Reihenfolge der `person-1`..`person-8`-Knöpfe im Optionskreis.
 * Index i (0-basiert) entspricht der SVG-`id` `person-${i+1}`.
 */
export const PERSON_ICON_ORDER: readonly PersonIcon[] = [
  'person-1', 'person-2', 'person-3', 'person-4',
  'person-5', 'person-6', 'person-7', 'person-8',
];
